<script>
    import NavItem from '$lib/components/NavItem.svelte';
    import ThemeSwitcher from '$lib/components/ThemeSwitcher.svelte';

    export let drawerMenuOpen;
    export let data;
</script>

<nav class="no-scrollbar max-h-screen overflow-y-auto overflow-x-hidden pb-60">
    <NavItem bind:drawerOpen={drawerMenuOpen} {data} />

    <div class="mt-6 p-2 pb-0">
        <span class="px-2 text-left text-base font-semibold dark:text-purple-300">App Settings</span>
        <div class="px-8 py-4">
            <ThemeSwitcher classes="text-2xl" />
        </div>
    </div>
</nav>
